export default function TestimonialCard({
  name,
  role,
  company,
  quote,
  rating,
  initials,
  result,
  className = "",
}) {
  const avatarText =
    initials ||
    name
      ?.split(" ")
      .map((part) => part[0])
      .join("")
      .slice(0, 2)
      .toUpperCase() ||
    "QA";

  return (
    <article className={`testimonial-card surface-card ${className}`.trim()}>
      <div className="testimonial-card-header">
        <div className="testimonial-avatar">{avatarText}</div>
        <div>
          <strong>{name}</strong>
          {(role || company) && (
            <span>
              {role}
              {role && company ? " at " : ""}
              {company}
            </span>
          )}
        </div>
      </div>
      {rating && <div className="testimonial-rating" aria-label={`${rating} out of 5 rating`}>{rating}/5</div>}
      {quote && <p>"{quote}"</p>}
      {result && <small>{result}</small>}
    </article>
  );
}
